// src/supabaseClient.js
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
// Prefer an explicit anon key var to avoid accidentally using the service role key in the browser.
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.REACT_APP_SUPABASE_KEY;

if (!supabaseUrl || !supabaseKey) {
  // Fail fast in dev if env vars are missing
  // eslint-disable-next-line no-console
  console.warn("Supabase client missing URL or anon key; check .env.local");
}

export const supabase = createClient(supabaseUrl, supabaseKey);
